/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfilesRouteImport } from './routes/profiles'
import { Route as DowntimeRouteImport } from './routes/downtime'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OfferingsIndexRouteImport } from './routes/offerings/index'
import { Route as OfferingsLayoutRouteImport } from './routes/offerings/_layout'
import { Route as OfferingsOfferIdRouteImport } from './routes/offerings/$offerId'
import { Route as TenantIdRegisterRouteImport } from './routes/$tenantId/register'
import { Route as TenantIdLogoutRouteImport } from './routes/$tenantId/logout'
import { Route as TenantIdLoginRouteImport } from './routes/$tenantId/login'
import { Route as TenantIdLayoutRouteImport } from './routes/$tenantId/_layout'
import { Route as TenantIdSelfServiceIndexRouteImport } from './routes/$tenantId/self-service/index'
import { Route as TenantIdMenuIndexRouteImport } from './routes/$tenantId/menu/index'
import { Route as TenantIdLayoutIndexRouteImport } from './routes/$tenantId/_layout/index'
import { Route as TenantIdSelfServiceLoginRouteImport } from './routes/$tenantId/self-service/login'
import { Route as TenantIdSelfServiceLayoutRouteImport } from './routes/$tenantId/self-service/_layout'
import { Route as TenantIdLayoutStudentsRouteImport } from './routes/$tenantId/_layout/students'
import { Route as TenantIdLayoutUserIndexRouteImport } from './routes/$tenantId/_layout/user/index'
import { Route as TenantIdLayoutTravellersIndexRouteImport } from './routes/$tenantId/_layout/travellers/index'
import { Route as TenantIdLayoutTicketsIndexRouteImport } from './routes/$tenantId/_layout/tickets/index'
import { Route as TenantIdLayoutTermsAndConditionsIndexRouteImport } from './routes/$tenantId/_layout/terms-and-conditions/index'
import { Route as TenantIdLayoutTenantSettingsIndexRouteImport } from './routes/$tenantId/_layout/tenant-settings/index'
import { Route as TenantIdLayoutSystemAdministratorsIndexRouteImport } from './routes/$tenantId/_layout/system-administrators/index'
import { Route as TenantIdLayoutSupportIndexRouteImport } from './routes/$tenantId/_layout/support/index'
import { Route as TenantIdLayoutStudentsIndexRouteImport } from './routes/$tenantId/_layout/students/index'
import { Route as TenantIdLayoutSearchIndexRouteImport } from './routes/$tenantId/_layout/search/index'
import { Route as TenantIdLayoutReportsIndexRouteImport } from './routes/$tenantId/_layout/reports/index'
import { Route as TenantIdLayoutPrivacyPolicyIndexRouteImport } from './routes/$tenantId/_layout/privacy-policy/index'
import { Route as TenantIdLayoutPortalInfoIndexRouteImport } from './routes/$tenantId/_layout/portal-info/index'
import { Route as TenantIdLayoutPeriodsIndexRouteImport } from './routes/$tenantId/_layout/periods/index'
import { Route as TenantIdLayoutPayersIndexRouteImport } from './routes/$tenantId/_layout/payers/index'
import { Route as TenantIdLayoutOrganizationsIndexRouteImport } from './routes/$tenantId/_layout/organizations/index'
import { Route as TenantIdLayoutOperatingStatusIndexRouteImport } from './routes/$tenantId/_layout/operating-status/index'
import { Route as TenantIdLayoutFaqIndexRouteImport } from './routes/$tenantId/_layout/faq/index'
import { Route as TenantIdLayoutDepartmentsIndexRouteImport } from './routes/$tenantId/_layout/departments/index'
import { Route as TenantIdLayoutBuyTicketIndexRouteImport } from './routes/$tenantId/_layout/buy-ticket/index'
import { Route as TenantIdLayoutAdministratorsIndexRouteImport } from './routes/$tenantId/_layout/administrators/index'
import { Route as TenantIdSelfServiceAuthVerifyRouteImport } from './routes/$tenantId/self-service/auth/verify'
import { Route as TenantIdSelfServiceLayoutDashboardRouteImport } from './routes/$tenantId/self-service/_layout/dashboard'
import { Route as TenantIdLayoutTenantSettingsViewRouteImport } from './routes/$tenantId/_layout/tenant-settings/$view'
import { Route as TenantIdLayoutReportsViewRouteImport } from './routes/$tenantId/_layout/reports/$view'
import { Route as TenantIdLayoutOrganizationsViewRouteImport } from './routes/$tenantId/_layout/organizations/$view'
import { Route as TenantIdLayoutDepartmentsLayoutRouteImport } from './routes/$tenantId/_layout/departments/_layout'
import { Route as TenantIdLayoutTravellersTravellerIdIndexRouteImport } from './routes/$tenantId/_layout/travellers/$travellerId/index'
import { Route as TenantIdLayoutTicketsTicketIdIndexRouteImport } from './routes/$tenantId/_layout/tickets/$ticketId/index'
import { Route as TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRouteImport } from './routes/$tenantId/_layout/system-administrators/$systemadministratorId/index'
import { Route as TenantIdLayoutStudentsTravelsIndexRouteImport } from './routes/$tenantId/_layout/students/travels/index'
import { Route as TenantIdLayoutStudentsTransportationIndexRouteImport } from './routes/$tenantId/_layout/students/transportation/index'
import { Route as TenantIdLayoutStudentsChildAndYouthIndexRouteImport } from './routes/$tenantId/_layout/students/child-and-youth/index'
import { Route as TenantIdLayoutAdministratorsAdministratorIdIndexRouteImport } from './routes/$tenantId/_layout/administrators/$administratorId/index'
import { Route as TenantIdLayoutTravellersTravellerIdViewRouteImport } from './routes/$tenantId/_layout/travellers/$travellerId/$view'
import { Route as TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRouteImport } from './routes/$tenantId/_layout/system-administrators/$systemadministratorId/$view'
import { Route as TenantIdLayoutStudentsTravelsImportRouteImport } from './routes/$tenantId/_layout/students/travels/import'
import { Route as TenantIdLayoutStudentsTravelsViewRouteImport } from './routes/$tenantId/_layout/students/travels/$view'
import { Route as TenantIdLayoutStudentsTransportationImportRouteImport } from './routes/$tenantId/_layout/students/transportation/import'
import { Route as TenantIdLayoutStudentsTransportationViewRouteImport } from './routes/$tenantId/_layout/students/transportation/$view'
import { Route as TenantIdLayoutStudentsChildAndYouthImportRouteImport } from './routes/$tenantId/_layout/students/child-and-youth/import'
import { Route as TenantIdLayoutStudentsChildAndYouthViewRouteImport } from './routes/$tenantId/_layout/students/child-and-youth/$view'
import { Route as TenantIdLayoutAdministratorsAdministratorIdViewRouteImport } from './routes/$tenantId/_layout/administrators/$administratorId/$view'
import { Route as TenantIdLayoutReportsTransactionsTransactionIdIndexRouteImport } from './routes/$tenantId/_layout/reports/transactions/$transactionId/index'
import { Route as TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRouteImport } from './routes/$tenantId/_layout/organizations/organization/$organizationId/index'
import { Route as TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRouteImport } from './routes/$tenantId/_layout/organizations/applications/$applicationId/index'
import { Route as TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRouteImport } from './routes/$tenantId/_layout/departments/_layout/$departmentId/index'
import { Route as TenantIdLayoutStudentsTravelsImportsImportIdRouteImport } from './routes/$tenantId/_layout/students/travels/imports/$importId'
import { Route as TenantIdLayoutStudentsTransportationImportsImportIdRouteImport } from './routes/$tenantId/_layout/students/transportation/imports/$importId'
import { Route as TenantIdLayoutStudentsChildAndYouthImportsImportIdRouteImport } from './routes/$tenantId/_layout/students/child-and-youth/imports/$importId'
import { Route as TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRouteImport } from './routes/$tenantId/_layout/organizations/organization/$organizationId/$view'
import { Route as TenantIdLayoutDepartmentsLayoutDepartmentIdViewRouteImport } from './routes/$tenantId/_layout/departments/_layout/$departmentId/$view'

const ProfilesRoute = ProfilesRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const DowntimeRoute = DowntimeRouteImport.update({
  id: '/downtime',
  path: '/downtime',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityRoute = AccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferingsIndexRoute = OfferingsIndexRouteImport.update({
  id: '/offerings/',
  path: '/offerings/',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferingsLayoutRoute = OfferingsLayoutRouteImport.update({
  id: '/offerings/_layout',
  path: '/offerings',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferingsOfferIdRoute = OfferingsOfferIdRouteImport.update({
  id: '/offerings/$offerId',
  path: '/offerings/$offerId',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantIdRegisterRoute = TenantIdRegisterRouteImport.update({
  id: '/$tenantId/register',
  path: '/$tenantId/register',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantIdLogoutRoute = TenantIdLogoutRouteImport.update({
  id: '/$tenantId/logout',
  path: '/$tenantId/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantIdLoginRoute = TenantIdLoginRouteImport.update({
  id: '/$tenantId/login',
  path: '/$tenantId/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantIdLayoutRoute = TenantIdLayoutRouteImport.update({
  id: '/$tenantId/_layout',
  path: '/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantIdSelfServiceIndexRoute =
  TenantIdSelfServiceIndexRouteImport.update({
    id: '/$tenantId/self-service/',
    path: '/$tenantId/self-service/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantIdMenuIndexRoute = TenantIdMenuIndexRouteImport.update({
  id: '/$tenantId/menu/',
  path: '/$tenantId/menu/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantIdLayoutIndexRoute = TenantIdLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TenantIdLayoutRoute,
} as any)
const TenantIdSelfServiceLoginRoute =
  TenantIdSelfServiceLoginRouteImport.update({
    id: '/$tenantId/self-service/login',
    path: '/$tenantId/self-service/login',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantIdSelfServiceLayoutRoute =
  TenantIdSelfServiceLayoutRouteImport.update({
    id: '/$tenantId/self-service/_layout',
    path: '/$tenantId/self-service',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantIdLayoutStudentsRoute = TenantIdLayoutStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => TenantIdLayoutRoute,
} as any)
const TenantIdLayoutUserIndexRoute = TenantIdLayoutUserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => TenantIdLayoutRoute,
} as any)
const TenantIdLayoutTravellersIndexRoute =
  TenantIdLayoutTravellersIndexRouteImport.update({
    id: '/travellers/',
    path: '/travellers/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutTicketsIndexRoute =
  TenantIdLayoutTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutTermsAndConditionsIndexRoute =
  TenantIdLayoutTermsAndConditionsIndexRouteImport.update({
    id: '/terms-and-conditions/',
    path: '/terms-and-conditions/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutTenantSettingsIndexRoute =
  TenantIdLayoutTenantSettingsIndexRouteImport.update({
    id: '/tenant-settings/',
    path: '/tenant-settings/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutSystemAdministratorsIndexRoute =
  TenantIdLayoutSystemAdministratorsIndexRouteImport.update({
    id: '/system-administrators/',
    path: '/system-administrators/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutSupportIndexRoute =
  TenantIdLayoutSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutStudentsIndexRoute =
  TenantIdLayoutStudentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutSearchIndexRoute =
  TenantIdLayoutSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutReportsIndexRoute =
  TenantIdLayoutReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutPrivacyPolicyIndexRoute =
  TenantIdLayoutPrivacyPolicyIndexRouteImport.update({
    id: '/privacy-policy/',
    path: '/privacy-policy/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutPortalInfoIndexRoute =
  TenantIdLayoutPortalInfoIndexRouteImport.update({
    id: '/portal-info/',
    path: '/portal-info/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutPeriodsIndexRoute =
  TenantIdLayoutPeriodsIndexRouteImport.update({
    id: '/periods/',
    path: '/periods/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutPayersIndexRoute =
  TenantIdLayoutPayersIndexRouteImport.update({
    id: '/payers/',
    path: '/payers/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutOrganizationsIndexRoute =
  TenantIdLayoutOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutOperatingStatusIndexRoute =
  TenantIdLayoutOperatingStatusIndexRouteImport.update({
    id: '/operating-status/',
    path: '/operating-status/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutFaqIndexRoute = TenantIdLayoutFaqIndexRouteImport.update({
  id: '/faq/',
  path: '/faq/',
  getParentRoute: () => TenantIdLayoutRoute,
} as any)
const TenantIdLayoutDepartmentsIndexRoute =
  TenantIdLayoutDepartmentsIndexRouteImport.update({
    id: '/departments/',
    path: '/departments/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutBuyTicketIndexRoute =
  TenantIdLayoutBuyTicketIndexRouteImport.update({
    id: '/buy-ticket/',
    path: '/buy-ticket/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutAdministratorsIndexRoute =
  TenantIdLayoutAdministratorsIndexRouteImport.update({
    id: '/administrators/',
    path: '/administrators/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdSelfServiceAuthVerifyRoute =
  TenantIdSelfServiceAuthVerifyRouteImport.update({
    id: '/$tenantId/self-service/auth/verify',
    path: '/$tenantId/self-service/auth/verify',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantIdSelfServiceLayoutDashboardRoute =
  TenantIdSelfServiceLayoutDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => TenantIdSelfServiceLayoutRoute,
  } as any)
const TenantIdLayoutTenantSettingsViewRoute =
  TenantIdLayoutTenantSettingsViewRouteImport.update({
    id: '/tenant-settings/$view',
    path: '/tenant-settings/$view',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutReportsViewRoute =
  TenantIdLayoutReportsViewRouteImport.update({
    id: '/reports/$view',
    path: '/reports/$view',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutOrganizationsViewRoute =
  TenantIdLayoutOrganizationsViewRouteImport.update({
    id: '/organizations/$view',
    path: '/organizations/$view',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutDepartmentsLayoutRoute =
  TenantIdLayoutDepartmentsLayoutRouteImport.update({
    id: '/departments/_layout',
    path: '/departments',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutTravellersTravellerIdIndexRoute =
  TenantIdLayoutTravellersTravellerIdIndexRouteImport.update({
    id: '/travellers/$travellerId/',
    path: '/travellers/$travellerId/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutTicketsTicketIdIndexRoute =
  TenantIdLayoutTicketsTicketIdIndexRouteImport.update({
    id: '/tickets/$ticketId/',
    path: '/tickets/$ticketId/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute =
  TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRouteImport.update(
    {
      id: '/system-administrators/$systemadministratorId/',
      path: '/system-administrators/$systemadministratorId/',
      getParentRoute: () => TenantIdLayoutRoute,
    } as any,
  )
const TenantIdLayoutStudentsTravelsIndexRoute =
  TenantIdLayoutStudentsTravelsIndexRouteImport.update({
    id: '/travels/',
    path: '/travels/',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsTransportationIndexRoute =
  TenantIdLayoutStudentsTransportationIndexRouteImport.update({
    id: '/transportation/',
    path: '/transportation/',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsChildAndYouthIndexRoute =
  TenantIdLayoutStudentsChildAndYouthIndexRouteImport.update({
    id: '/child-and-youth/',
    path: '/child-and-youth/',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutAdministratorsAdministratorIdIndexRoute =
  TenantIdLayoutAdministratorsAdministratorIdIndexRouteImport.update({
    id: '/administrators/$administratorId/',
    path: '/administrators/$administratorId/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutTravellersTravellerIdViewRoute =
  TenantIdLayoutTravellersTravellerIdViewRouteImport.update({
    id: '/travellers/$travellerId/$view',
    path: '/travellers/$travellerId/$view',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute =
  TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRouteImport.update(
    {
      id: '/system-administrators/$systemadministratorId/$view',
      path: '/system-administrators/$systemadministratorId/$view',
      getParentRoute: () => TenantIdLayoutRoute,
    } as any,
  )
const TenantIdLayoutStudentsTravelsImportRoute =
  TenantIdLayoutStudentsTravelsImportRouteImport.update({
    id: '/travels/import',
    path: '/travels/import',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsTravelsViewRoute =
  TenantIdLayoutStudentsTravelsViewRouteImport.update({
    id: '/travels/$view',
    path: '/travels/$view',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsTransportationImportRoute =
  TenantIdLayoutStudentsTransportationImportRouteImport.update({
    id: '/transportation/import',
    path: '/transportation/import',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsTransportationViewRoute =
  TenantIdLayoutStudentsTransportationViewRouteImport.update({
    id: '/transportation/$view',
    path: '/transportation/$view',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsChildAndYouthImportRoute =
  TenantIdLayoutStudentsChildAndYouthImportRouteImport.update({
    id: '/child-and-youth/import',
    path: '/child-and-youth/import',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsChildAndYouthViewRoute =
  TenantIdLayoutStudentsChildAndYouthViewRouteImport.update({
    id: '/child-and-youth/$view',
    path: '/child-and-youth/$view',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutAdministratorsAdministratorIdViewRoute =
  TenantIdLayoutAdministratorsAdministratorIdViewRouteImport.update({
    id: '/administrators/$administratorId/$view',
    path: '/administrators/$administratorId/$view',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutReportsTransactionsTransactionIdIndexRoute =
  TenantIdLayoutReportsTransactionsTransactionIdIndexRouteImport.update({
    id: '/reports/transactions/$transactionId/',
    path: '/reports/transactions/$transactionId/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute =
  TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRouteImport.update({
    id: '/organizations/organization/$organizationId/',
    path: '/organizations/organization/$organizationId/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute =
  TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRouteImport.update({
    id: '/organizations/applications/$applicationId/',
    path: '/organizations/applications/$applicationId/',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute =
  TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRouteImport.update({
    id: '/$departmentId/',
    path: '/$departmentId/',
    getParentRoute: () => TenantIdLayoutDepartmentsLayoutRoute,
  } as any)
const TenantIdLayoutStudentsTravelsImportsImportIdRoute =
  TenantIdLayoutStudentsTravelsImportsImportIdRouteImport.update({
    id: '/travels/imports/$importId',
    path: '/travels/imports/$importId',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsTransportationImportsImportIdRoute =
  TenantIdLayoutStudentsTransportationImportsImportIdRouteImport.update({
    id: '/transportation/imports/$importId',
    path: '/transportation/imports/$importId',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute =
  TenantIdLayoutStudentsChildAndYouthImportsImportIdRouteImport.update({
    id: '/child-and-youth/imports/$importId',
    path: '/child-and-youth/imports/$importId',
    getParentRoute: () => TenantIdLayoutStudentsRoute,
  } as any)
const TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute =
  TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRouteImport.update({
    id: '/organizations/organization/$organizationId/$view',
    path: '/organizations/organization/$organizationId/$view',
    getParentRoute: () => TenantIdLayoutRoute,
  } as any)
const TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute =
  TenantIdLayoutDepartmentsLayoutDepartmentIdViewRouteImport.update({
    id: '/$departmentId/$view',
    path: '/$departmentId/$view',
    getParentRoute: () => TenantIdLayoutDepartmentsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRoute
  '/downtime': typeof DowntimeRoute
  '/profiles': typeof ProfilesRoute
  '/$tenantId': typeof TenantIdLayoutRouteWithChildren
  '/$tenantId/login': typeof TenantIdLoginRoute
  '/$tenantId/logout': typeof TenantIdLogoutRoute
  '/$tenantId/register': typeof TenantIdRegisterRoute
  '/offerings/$offerId': typeof OfferingsOfferIdRoute
  '/offerings': typeof OfferingsLayoutRoute
  '/offerings/': typeof OfferingsIndexRoute
  '/$tenantId/students': typeof TenantIdLayoutStudentsRouteWithChildren
  '/$tenantId/self-service': typeof TenantIdSelfServiceLayoutRouteWithChildren
  '/$tenantId/self-service/login': typeof TenantIdSelfServiceLoginRoute
  '/$tenantId/': typeof TenantIdLayoutIndexRoute
  '/$tenantId/menu/': typeof TenantIdMenuIndexRoute
  '/$tenantId/self-service/': typeof TenantIdSelfServiceIndexRoute
  '/$tenantId/departments': typeof TenantIdLayoutDepartmentsLayoutRouteWithChildren
  '/$tenantId/organizations/$view': typeof TenantIdLayoutOrganizationsViewRoute
  '/$tenantId/reports/$view': typeof TenantIdLayoutReportsViewRoute
  '/$tenantId/tenant-settings/$view': typeof TenantIdLayoutTenantSettingsViewRoute
  '/$tenantId/self-service/dashboard': typeof TenantIdSelfServiceLayoutDashboardRoute
  '/$tenantId/self-service/auth/verify': typeof TenantIdSelfServiceAuthVerifyRoute
  '/$tenantId/administrators/': typeof TenantIdLayoutAdministratorsIndexRoute
  '/$tenantId/buy-ticket/': typeof TenantIdLayoutBuyTicketIndexRoute
  '/$tenantId/departments/': typeof TenantIdLayoutDepartmentsIndexRoute
  '/$tenantId/faq/': typeof TenantIdLayoutFaqIndexRoute
  '/$tenantId/operating-status/': typeof TenantIdLayoutOperatingStatusIndexRoute
  '/$tenantId/organizations/': typeof TenantIdLayoutOrganizationsIndexRoute
  '/$tenantId/payers/': typeof TenantIdLayoutPayersIndexRoute
  '/$tenantId/periods/': typeof TenantIdLayoutPeriodsIndexRoute
  '/$tenantId/portal-info/': typeof TenantIdLayoutPortalInfoIndexRoute
  '/$tenantId/privacy-policy/': typeof TenantIdLayoutPrivacyPolicyIndexRoute
  '/$tenantId/reports/': typeof TenantIdLayoutReportsIndexRoute
  '/$tenantId/search/': typeof TenantIdLayoutSearchIndexRoute
  '/$tenantId/students/': typeof TenantIdLayoutStudentsIndexRoute
  '/$tenantId/support/': typeof TenantIdLayoutSupportIndexRoute
  '/$tenantId/system-administrators/': typeof TenantIdLayoutSystemAdministratorsIndexRoute
  '/$tenantId/tenant-settings/': typeof TenantIdLayoutTenantSettingsIndexRoute
  '/$tenantId/terms-and-conditions/': typeof TenantIdLayoutTermsAndConditionsIndexRoute
  '/$tenantId/tickets/': typeof TenantIdLayoutTicketsIndexRoute
  '/$tenantId/travellers/': typeof TenantIdLayoutTravellersIndexRoute
  '/$tenantId/user/': typeof TenantIdLayoutUserIndexRoute
  '/$tenantId/administrators/$administratorId/$view': typeof TenantIdLayoutAdministratorsAdministratorIdViewRoute
  '/$tenantId/students/child-and-youth/$view': typeof TenantIdLayoutStudentsChildAndYouthViewRoute
  '/$tenantId/students/child-and-youth/import': typeof TenantIdLayoutStudentsChildAndYouthImportRoute
  '/$tenantId/students/transportation/$view': typeof TenantIdLayoutStudentsTransportationViewRoute
  '/$tenantId/students/transportation/import': typeof TenantIdLayoutStudentsTransportationImportRoute
  '/$tenantId/students/travels/$view': typeof TenantIdLayoutStudentsTravelsViewRoute
  '/$tenantId/students/travels/import': typeof TenantIdLayoutStudentsTravelsImportRoute
  '/$tenantId/system-administrators/$systemadministratorId/$view': typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute
  '/$tenantId/travellers/$travellerId/$view': typeof TenantIdLayoutTravellersTravellerIdViewRoute
  '/$tenantId/administrators/$administratorId/': typeof TenantIdLayoutAdministratorsAdministratorIdIndexRoute
  '/$tenantId/students/child-and-youth/': typeof TenantIdLayoutStudentsChildAndYouthIndexRoute
  '/$tenantId/students/transportation/': typeof TenantIdLayoutStudentsTransportationIndexRoute
  '/$tenantId/students/travels/': typeof TenantIdLayoutStudentsTravelsIndexRoute
  '/$tenantId/system-administrators/$systemadministratorId/': typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute
  '/$tenantId/tickets/$ticketId/': typeof TenantIdLayoutTicketsTicketIdIndexRoute
  '/$tenantId/travellers/$travellerId/': typeof TenantIdLayoutTravellersTravellerIdIndexRoute
  '/$tenantId/departments/$departmentId/$view': typeof TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute
  '/$tenantId/organizations/organization/$organizationId/$view': typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute
  '/$tenantId/students/child-and-youth/imports/$importId': typeof TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute
  '/$tenantId/students/transportation/imports/$importId': typeof TenantIdLayoutStudentsTransportationImportsImportIdRoute
  '/$tenantId/students/travels/imports/$importId': typeof TenantIdLayoutStudentsTravelsImportsImportIdRoute
  '/$tenantId/departments/$departmentId/': typeof TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute
  '/$tenantId/organizations/applications/$applicationId/': typeof TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute
  '/$tenantId/organizations/organization/$organizationId/': typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute
  '/$tenantId/reports/transactions/$transactionId/': typeof TenantIdLayoutReportsTransactionsTransactionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRoute
  '/downtime': typeof DowntimeRoute
  '/profiles': typeof ProfilesRoute
  '/$tenantId/login': typeof TenantIdLoginRoute
  '/$tenantId/logout': typeof TenantIdLogoutRoute
  '/$tenantId/register': typeof TenantIdRegisterRoute
  '/offerings/$offerId': typeof OfferingsOfferIdRoute
  '/offerings': typeof OfferingsIndexRoute
  '/$tenantId/self-service': typeof TenantIdSelfServiceIndexRoute
  '/$tenantId/self-service/login': typeof TenantIdSelfServiceLoginRoute
  '/$tenantId': typeof TenantIdLayoutIndexRoute
  '/$tenantId/menu': typeof TenantIdMenuIndexRoute
  '/$tenantId/departments': typeof TenantIdLayoutDepartmentsIndexRoute
  '/$tenantId/organizations/$view': typeof TenantIdLayoutOrganizationsViewRoute
  '/$tenantId/reports/$view': typeof TenantIdLayoutReportsViewRoute
  '/$tenantId/tenant-settings/$view': typeof TenantIdLayoutTenantSettingsViewRoute
  '/$tenantId/self-service/dashboard': typeof TenantIdSelfServiceLayoutDashboardRoute
  '/$tenantId/self-service/auth/verify': typeof TenantIdSelfServiceAuthVerifyRoute
  '/$tenantId/administrators': typeof TenantIdLayoutAdministratorsIndexRoute
  '/$tenantId/buy-ticket': typeof TenantIdLayoutBuyTicketIndexRoute
  '/$tenantId/faq': typeof TenantIdLayoutFaqIndexRoute
  '/$tenantId/operating-status': typeof TenantIdLayoutOperatingStatusIndexRoute
  '/$tenantId/organizations': typeof TenantIdLayoutOrganizationsIndexRoute
  '/$tenantId/payers': typeof TenantIdLayoutPayersIndexRoute
  '/$tenantId/periods': typeof TenantIdLayoutPeriodsIndexRoute
  '/$tenantId/portal-info': typeof TenantIdLayoutPortalInfoIndexRoute
  '/$tenantId/privacy-policy': typeof TenantIdLayoutPrivacyPolicyIndexRoute
  '/$tenantId/reports': typeof TenantIdLayoutReportsIndexRoute
  '/$tenantId/search': typeof TenantIdLayoutSearchIndexRoute
  '/$tenantId/students': typeof TenantIdLayoutStudentsIndexRoute
  '/$tenantId/support': typeof TenantIdLayoutSupportIndexRoute
  '/$tenantId/system-administrators': typeof TenantIdLayoutSystemAdministratorsIndexRoute
  '/$tenantId/tenant-settings': typeof TenantIdLayoutTenantSettingsIndexRoute
  '/$tenantId/terms-and-conditions': typeof TenantIdLayoutTermsAndConditionsIndexRoute
  '/$tenantId/tickets': typeof TenantIdLayoutTicketsIndexRoute
  '/$tenantId/travellers': typeof TenantIdLayoutTravellersIndexRoute
  '/$tenantId/user': typeof TenantIdLayoutUserIndexRoute
  '/$tenantId/administrators/$administratorId/$view': typeof TenantIdLayoutAdministratorsAdministratorIdViewRoute
  '/$tenantId/students/child-and-youth/$view': typeof TenantIdLayoutStudentsChildAndYouthViewRoute
  '/$tenantId/students/child-and-youth/import': typeof TenantIdLayoutStudentsChildAndYouthImportRoute
  '/$tenantId/students/transportation/$view': typeof TenantIdLayoutStudentsTransportationViewRoute
  '/$tenantId/students/transportation/import': typeof TenantIdLayoutStudentsTransportationImportRoute
  '/$tenantId/students/travels/$view': typeof TenantIdLayoutStudentsTravelsViewRoute
  '/$tenantId/students/travels/import': typeof TenantIdLayoutStudentsTravelsImportRoute
  '/$tenantId/system-administrators/$systemadministratorId/$view': typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute
  '/$tenantId/travellers/$travellerId/$view': typeof TenantIdLayoutTravellersTravellerIdViewRoute
  '/$tenantId/administrators/$administratorId': typeof TenantIdLayoutAdministratorsAdministratorIdIndexRoute
  '/$tenantId/students/child-and-youth': typeof TenantIdLayoutStudentsChildAndYouthIndexRoute
  '/$tenantId/students/transportation': typeof TenantIdLayoutStudentsTransportationIndexRoute
  '/$tenantId/students/travels': typeof TenantIdLayoutStudentsTravelsIndexRoute
  '/$tenantId/system-administrators/$systemadministratorId': typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute
  '/$tenantId/tickets/$ticketId': typeof TenantIdLayoutTicketsTicketIdIndexRoute
  '/$tenantId/travellers/$travellerId': typeof TenantIdLayoutTravellersTravellerIdIndexRoute
  '/$tenantId/departments/$departmentId/$view': typeof TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute
  '/$tenantId/organizations/organization/$organizationId/$view': typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute
  '/$tenantId/students/child-and-youth/imports/$importId': typeof TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute
  '/$tenantId/students/transportation/imports/$importId': typeof TenantIdLayoutStudentsTransportationImportsImportIdRoute
  '/$tenantId/students/travels/imports/$importId': typeof TenantIdLayoutStudentsTravelsImportsImportIdRoute
  '/$tenantId/departments/$departmentId': typeof TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute
  '/$tenantId/organizations/applications/$applicationId': typeof TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute
  '/$tenantId/organizations/organization/$organizationId': typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute
  '/$tenantId/reports/transactions/$transactionId': typeof TenantIdLayoutReportsTransactionsTransactionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRoute
  '/downtime': typeof DowntimeRoute
  '/profiles': typeof ProfilesRoute
  '/$tenantId/_layout': typeof TenantIdLayoutRouteWithChildren
  '/$tenantId/login': typeof TenantIdLoginRoute
  '/$tenantId/logout': typeof TenantIdLogoutRoute
  '/$tenantId/register': typeof TenantIdRegisterRoute
  '/offerings/$offerId': typeof OfferingsOfferIdRoute
  '/offerings/_layout': typeof OfferingsLayoutRoute
  '/offerings/': typeof OfferingsIndexRoute
  '/$tenantId/_layout/students': typeof TenantIdLayoutStudentsRouteWithChildren
  '/$tenantId/self-service/_layout': typeof TenantIdSelfServiceLayoutRouteWithChildren
  '/$tenantId/self-service/login': typeof TenantIdSelfServiceLoginRoute
  '/$tenantId/_layout/': typeof TenantIdLayoutIndexRoute
  '/$tenantId/menu/': typeof TenantIdMenuIndexRoute
  '/$tenantId/self-service/': typeof TenantIdSelfServiceIndexRoute
  '/$tenantId/_layout/departments/_layout': typeof TenantIdLayoutDepartmentsLayoutRouteWithChildren
  '/$tenantId/_layout/organizations/$view': typeof TenantIdLayoutOrganizationsViewRoute
  '/$tenantId/_layout/reports/$view': typeof TenantIdLayoutReportsViewRoute
  '/$tenantId/_layout/tenant-settings/$view': typeof TenantIdLayoutTenantSettingsViewRoute
  '/$tenantId/self-service/_layout/dashboard': typeof TenantIdSelfServiceLayoutDashboardRoute
  '/$tenantId/self-service/auth/verify': typeof TenantIdSelfServiceAuthVerifyRoute
  '/$tenantId/_layout/administrators/': typeof TenantIdLayoutAdministratorsIndexRoute
  '/$tenantId/_layout/buy-ticket/': typeof TenantIdLayoutBuyTicketIndexRoute
  '/$tenantId/_layout/departments/': typeof TenantIdLayoutDepartmentsIndexRoute
  '/$tenantId/_layout/faq/': typeof TenantIdLayoutFaqIndexRoute
  '/$tenantId/_layout/operating-status/': typeof TenantIdLayoutOperatingStatusIndexRoute
  '/$tenantId/_layout/organizations/': typeof TenantIdLayoutOrganizationsIndexRoute
  '/$tenantId/_layout/payers/': typeof TenantIdLayoutPayersIndexRoute
  '/$tenantId/_layout/periods/': typeof TenantIdLayoutPeriodsIndexRoute
  '/$tenantId/_layout/portal-info/': typeof TenantIdLayoutPortalInfoIndexRoute
  '/$tenantId/_layout/privacy-policy/': typeof TenantIdLayoutPrivacyPolicyIndexRoute
  '/$tenantId/_layout/reports/': typeof TenantIdLayoutReportsIndexRoute
  '/$tenantId/_layout/search/': typeof TenantIdLayoutSearchIndexRoute
  '/$tenantId/_layout/students/': typeof TenantIdLayoutStudentsIndexRoute
  '/$tenantId/_layout/support/': typeof TenantIdLayoutSupportIndexRoute
  '/$tenantId/_layout/system-administrators/': typeof TenantIdLayoutSystemAdministratorsIndexRoute
  '/$tenantId/_layout/tenant-settings/': typeof TenantIdLayoutTenantSettingsIndexRoute
  '/$tenantId/_layout/terms-and-conditions/': typeof TenantIdLayoutTermsAndConditionsIndexRoute
  '/$tenantId/_layout/tickets/': typeof TenantIdLayoutTicketsIndexRoute
  '/$tenantId/_layout/travellers/': typeof TenantIdLayoutTravellersIndexRoute
  '/$tenantId/_layout/user/': typeof TenantIdLayoutUserIndexRoute
  '/$tenantId/_layout/administrators/$administratorId/$view': typeof TenantIdLayoutAdministratorsAdministratorIdViewRoute
  '/$tenantId/_layout/students/child-and-youth/$view': typeof TenantIdLayoutStudentsChildAndYouthViewRoute
  '/$tenantId/_layout/students/child-and-youth/import': typeof TenantIdLayoutStudentsChildAndYouthImportRoute
  '/$tenantId/_layout/students/transportation/$view': typeof TenantIdLayoutStudentsTransportationViewRoute
  '/$tenantId/_layout/students/transportation/import': typeof TenantIdLayoutStudentsTransportationImportRoute
  '/$tenantId/_layout/students/travels/$view': typeof TenantIdLayoutStudentsTravelsViewRoute
  '/$tenantId/_layout/students/travels/import': typeof TenantIdLayoutStudentsTravelsImportRoute
  '/$tenantId/_layout/system-administrators/$systemadministratorId/$view': typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute
  '/$tenantId/_layout/travellers/$travellerId/$view': typeof TenantIdLayoutTravellersTravellerIdViewRoute
  '/$tenantId/_layout/administrators/$administratorId/': typeof TenantIdLayoutAdministratorsAdministratorIdIndexRoute
  '/$tenantId/_layout/students/child-and-youth/': typeof TenantIdLayoutStudentsChildAndYouthIndexRoute
  '/$tenantId/_layout/students/transportation/': typeof TenantIdLayoutStudentsTransportationIndexRoute
  '/$tenantId/_layout/students/travels/': typeof TenantIdLayoutStudentsTravelsIndexRoute
  '/$tenantId/_layout/system-administrators/$systemadministratorId/': typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute
  '/$tenantId/_layout/tickets/$ticketId/': typeof TenantIdLayoutTicketsTicketIdIndexRoute
  '/$tenantId/_layout/travellers/$travellerId/': typeof TenantIdLayoutTravellersTravellerIdIndexRoute
  '/$tenantId/_layout/departments/_layout/$departmentId/$view': typeof TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute
  '/$tenantId/_layout/organizations/organization/$organizationId/$view': typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute
  '/$tenantId/_layout/students/child-and-youth/imports/$importId': typeof TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute
  '/$tenantId/_layout/students/transportation/imports/$importId': typeof TenantIdLayoutStudentsTransportationImportsImportIdRoute
  '/$tenantId/_layout/students/travels/imports/$importId': typeof TenantIdLayoutStudentsTravelsImportsImportIdRoute
  '/$tenantId/_layout/departments/_layout/$departmentId/': typeof TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute
  '/$tenantId/_layout/organizations/applications/$applicationId/': typeof TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute
  '/$tenantId/_layout/organizations/organization/$organizationId/': typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute
  '/$tenantId/_layout/reports/transactions/$transactionId/': typeof TenantIdLayoutReportsTransactionsTransactionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accessibility'
    | '/downtime'
    | '/profiles'
    | '/$tenantId'
    | '/$tenantId/login'
    | '/$tenantId/logout'
    | '/$tenantId/register'
    | '/offerings/$offerId'
    | '/offerings'
    | '/offerings/'
    | '/$tenantId/students'
    | '/$tenantId/self-service'
    | '/$tenantId/self-service/login'
    | '/$tenantId/'
    | '/$tenantId/menu/'
    | '/$tenantId/self-service/'
    | '/$tenantId/departments'
    | '/$tenantId/organizations/$view'
    | '/$tenantId/reports/$view'
    | '/$tenantId/tenant-settings/$view'
    | '/$tenantId/self-service/dashboard'
    | '/$tenantId/self-service/auth/verify'
    | '/$tenantId/administrators/'
    | '/$tenantId/buy-ticket/'
    | '/$tenantId/departments/'
    | '/$tenantId/faq/'
    | '/$tenantId/operating-status/'
    | '/$tenantId/organizations/'
    | '/$tenantId/payers/'
    | '/$tenantId/periods/'
    | '/$tenantId/portal-info/'
    | '/$tenantId/privacy-policy/'
    | '/$tenantId/reports/'
    | '/$tenantId/search/'
    | '/$tenantId/students/'
    | '/$tenantId/support/'
    | '/$tenantId/system-administrators/'
    | '/$tenantId/tenant-settings/'
    | '/$tenantId/terms-and-conditions/'
    | '/$tenantId/tickets/'
    | '/$tenantId/travellers/'
    | '/$tenantId/user/'
    | '/$tenantId/administrators/$administratorId/$view'
    | '/$tenantId/students/child-and-youth/$view'
    | '/$tenantId/students/child-and-youth/import'
    | '/$tenantId/students/transportation/$view'
    | '/$tenantId/students/transportation/import'
    | '/$tenantId/students/travels/$view'
    | '/$tenantId/students/travels/import'
    | '/$tenantId/system-administrators/$systemadministratorId/$view'
    | '/$tenantId/travellers/$travellerId/$view'
    | '/$tenantId/administrators/$administratorId/'
    | '/$tenantId/students/child-and-youth/'
    | '/$tenantId/students/transportation/'
    | '/$tenantId/students/travels/'
    | '/$tenantId/system-administrators/$systemadministratorId/'
    | '/$tenantId/tickets/$ticketId/'
    | '/$tenantId/travellers/$travellerId/'
    | '/$tenantId/departments/$departmentId/$view'
    | '/$tenantId/organizations/organization/$organizationId/$view'
    | '/$tenantId/students/child-and-youth/imports/$importId'
    | '/$tenantId/students/transportation/imports/$importId'
    | '/$tenantId/students/travels/imports/$importId'
    | '/$tenantId/departments/$departmentId/'
    | '/$tenantId/organizations/applications/$applicationId/'
    | '/$tenantId/organizations/organization/$organizationId/'
    | '/$tenantId/reports/transactions/$transactionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accessibility'
    | '/downtime'
    | '/profiles'
    | '/$tenantId/login'
    | '/$tenantId/logout'
    | '/$tenantId/register'
    | '/offerings/$offerId'
    | '/offerings'
    | '/$tenantId/self-service'
    | '/$tenantId/self-service/login'
    | '/$tenantId'
    | '/$tenantId/menu'
    | '/$tenantId/departments'
    | '/$tenantId/organizations/$view'
    | '/$tenantId/reports/$view'
    | '/$tenantId/tenant-settings/$view'
    | '/$tenantId/self-service/dashboard'
    | '/$tenantId/self-service/auth/verify'
    | '/$tenantId/administrators'
    | '/$tenantId/buy-ticket'
    | '/$tenantId/faq'
    | '/$tenantId/operating-status'
    | '/$tenantId/organizations'
    | '/$tenantId/payers'
    | '/$tenantId/periods'
    | '/$tenantId/portal-info'
    | '/$tenantId/privacy-policy'
    | '/$tenantId/reports'
    | '/$tenantId/search'
    | '/$tenantId/students'
    | '/$tenantId/support'
    | '/$tenantId/system-administrators'
    | '/$tenantId/tenant-settings'
    | '/$tenantId/terms-and-conditions'
    | '/$tenantId/tickets'
    | '/$tenantId/travellers'
    | '/$tenantId/user'
    | '/$tenantId/administrators/$administratorId/$view'
    | '/$tenantId/students/child-and-youth/$view'
    | '/$tenantId/students/child-and-youth/import'
    | '/$tenantId/students/transportation/$view'
    | '/$tenantId/students/transportation/import'
    | '/$tenantId/students/travels/$view'
    | '/$tenantId/students/travels/import'
    | '/$tenantId/system-administrators/$systemadministratorId/$view'
    | '/$tenantId/travellers/$travellerId/$view'
    | '/$tenantId/administrators/$administratorId'
    | '/$tenantId/students/child-and-youth'
    | '/$tenantId/students/transportation'
    | '/$tenantId/students/travels'
    | '/$tenantId/system-administrators/$systemadministratorId'
    | '/$tenantId/tickets/$ticketId'
    | '/$tenantId/travellers/$travellerId'
    | '/$tenantId/departments/$departmentId/$view'
    | '/$tenantId/organizations/organization/$organizationId/$view'
    | '/$tenantId/students/child-and-youth/imports/$importId'
    | '/$tenantId/students/transportation/imports/$importId'
    | '/$tenantId/students/travels/imports/$importId'
    | '/$tenantId/departments/$departmentId'
    | '/$tenantId/organizations/applications/$applicationId'
    | '/$tenantId/organizations/organization/$organizationId'
    | '/$tenantId/reports/transactions/$transactionId'
  id:
    | '__root__'
    | '/'
    | '/accessibility'
    | '/downtime'
    | '/profiles'
    | '/$tenantId/_layout'
    | '/$tenantId/login'
    | '/$tenantId/logout'
    | '/$tenantId/register'
    | '/offerings/$offerId'
    | '/offerings/_layout'
    | '/offerings/'
    | '/$tenantId/_layout/students'
    | '/$tenantId/self-service/_layout'
    | '/$tenantId/self-service/login'
    | '/$tenantId/_layout/'
    | '/$tenantId/menu/'
    | '/$tenantId/self-service/'
    | '/$tenantId/_layout/departments/_layout'
    | '/$tenantId/_layout/organizations/$view'
    | '/$tenantId/_layout/reports/$view'
    | '/$tenantId/_layout/tenant-settings/$view'
    | '/$tenantId/self-service/_layout/dashboard'
    | '/$tenantId/self-service/auth/verify'
    | '/$tenantId/_layout/administrators/'
    | '/$tenantId/_layout/buy-ticket/'
    | '/$tenantId/_layout/departments/'
    | '/$tenantId/_layout/faq/'
    | '/$tenantId/_layout/operating-status/'
    | '/$tenantId/_layout/organizations/'
    | '/$tenantId/_layout/payers/'
    | '/$tenantId/_layout/periods/'
    | '/$tenantId/_layout/portal-info/'
    | '/$tenantId/_layout/privacy-policy/'
    | '/$tenantId/_layout/reports/'
    | '/$tenantId/_layout/search/'
    | '/$tenantId/_layout/students/'
    | '/$tenantId/_layout/support/'
    | '/$tenantId/_layout/system-administrators/'
    | '/$tenantId/_layout/tenant-settings/'
    | '/$tenantId/_layout/terms-and-conditions/'
    | '/$tenantId/_layout/tickets/'
    | '/$tenantId/_layout/travellers/'
    | '/$tenantId/_layout/user/'
    | '/$tenantId/_layout/administrators/$administratorId/$view'
    | '/$tenantId/_layout/students/child-and-youth/$view'
    | '/$tenantId/_layout/students/child-and-youth/import'
    | '/$tenantId/_layout/students/transportation/$view'
    | '/$tenantId/_layout/students/transportation/import'
    | '/$tenantId/_layout/students/travels/$view'
    | '/$tenantId/_layout/students/travels/import'
    | '/$tenantId/_layout/system-administrators/$systemadministratorId/$view'
    | '/$tenantId/_layout/travellers/$travellerId/$view'
    | '/$tenantId/_layout/administrators/$administratorId/'
    | '/$tenantId/_layout/students/child-and-youth/'
    | '/$tenantId/_layout/students/transportation/'
    | '/$tenantId/_layout/students/travels/'
    | '/$tenantId/_layout/system-administrators/$systemadministratorId/'
    | '/$tenantId/_layout/tickets/$ticketId/'
    | '/$tenantId/_layout/travellers/$travellerId/'
    | '/$tenantId/_layout/departments/_layout/$departmentId/$view'
    | '/$tenantId/_layout/organizations/organization/$organizationId/$view'
    | '/$tenantId/_layout/students/child-and-youth/imports/$importId'
    | '/$tenantId/_layout/students/transportation/imports/$importId'
    | '/$tenantId/_layout/students/travels/imports/$importId'
    | '/$tenantId/_layout/departments/_layout/$departmentId/'
    | '/$tenantId/_layout/organizations/applications/$applicationId/'
    | '/$tenantId/_layout/organizations/organization/$organizationId/'
    | '/$tenantId/_layout/reports/transactions/$transactionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessibilityRoute: typeof AccessibilityRoute
  DowntimeRoute: typeof DowntimeRoute
  ProfilesRoute: typeof ProfilesRoute
  TenantIdLayoutRoute: typeof TenantIdLayoutRouteWithChildren
  TenantIdLoginRoute: typeof TenantIdLoginRoute
  TenantIdLogoutRoute: typeof TenantIdLogoutRoute
  TenantIdRegisterRoute: typeof TenantIdRegisterRoute
  OfferingsOfferIdRoute: typeof OfferingsOfferIdRoute
  OfferingsLayoutRoute: typeof OfferingsLayoutRoute
  OfferingsIndexRoute: typeof OfferingsIndexRoute
  TenantIdSelfServiceLayoutRoute: typeof TenantIdSelfServiceLayoutRouteWithChildren
  TenantIdSelfServiceLoginRoute: typeof TenantIdSelfServiceLoginRoute
  TenantIdMenuIndexRoute: typeof TenantIdMenuIndexRoute
  TenantIdSelfServiceIndexRoute: typeof TenantIdSelfServiceIndexRoute
  TenantIdSelfServiceAuthVerifyRoute: typeof TenantIdSelfServiceAuthVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profiles': {
      id: '/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof ProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downtime': {
      id: '/downtime'
      path: '/downtime'
      fullPath: '/downtime'
      preLoaderRoute: typeof DowntimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility': {
      id: '/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AccessibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offerings/': {
      id: '/offerings/'
      path: '/offerings'
      fullPath: '/offerings/'
      preLoaderRoute: typeof OfferingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offerings/_layout': {
      id: '/offerings/_layout'
      path: '/offerings'
      fullPath: '/offerings'
      preLoaderRoute: typeof OfferingsLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offerings/$offerId': {
      id: '/offerings/$offerId'
      path: '/offerings/$offerId'
      fullPath: '/offerings/$offerId'
      preLoaderRoute: typeof OfferingsOfferIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/register': {
      id: '/$tenantId/register'
      path: '/$tenantId/register'
      fullPath: '/$tenantId/register'
      preLoaderRoute: typeof TenantIdRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/logout': {
      id: '/$tenantId/logout'
      path: '/$tenantId/logout'
      fullPath: '/$tenantId/logout'
      preLoaderRoute: typeof TenantIdLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/login': {
      id: '/$tenantId/login'
      path: '/$tenantId/login'
      fullPath: '/$tenantId/login'
      preLoaderRoute: typeof TenantIdLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/_layout': {
      id: '/$tenantId/_layout'
      path: '/$tenantId'
      fullPath: '/$tenantId'
      preLoaderRoute: typeof TenantIdLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/self-service/': {
      id: '/$tenantId/self-service/'
      path: '/$tenantId/self-service'
      fullPath: '/$tenantId/self-service/'
      preLoaderRoute: typeof TenantIdSelfServiceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/menu/': {
      id: '/$tenantId/menu/'
      path: '/$tenantId/menu'
      fullPath: '/$tenantId/menu/'
      preLoaderRoute: typeof TenantIdMenuIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/_layout/': {
      id: '/$tenantId/_layout/'
      path: '/'
      fullPath: '/$tenantId/'
      preLoaderRoute: typeof TenantIdLayoutIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/self-service/login': {
      id: '/$tenantId/self-service/login'
      path: '/$tenantId/self-service/login'
      fullPath: '/$tenantId/self-service/login'
      preLoaderRoute: typeof TenantIdSelfServiceLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/self-service/_layout': {
      id: '/$tenantId/self-service/_layout'
      path: '/$tenantId/self-service'
      fullPath: '/$tenantId/self-service'
      preLoaderRoute: typeof TenantIdSelfServiceLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/_layout/students': {
      id: '/$tenantId/_layout/students'
      path: '/students'
      fullPath: '/$tenantId/students'
      preLoaderRoute: typeof TenantIdLayoutStudentsRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/user/': {
      id: '/$tenantId/_layout/user/'
      path: '/user'
      fullPath: '/$tenantId/user/'
      preLoaderRoute: typeof TenantIdLayoutUserIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/travellers/': {
      id: '/$tenantId/_layout/travellers/'
      path: '/travellers'
      fullPath: '/$tenantId/travellers/'
      preLoaderRoute: typeof TenantIdLayoutTravellersIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/tickets/': {
      id: '/$tenantId/_layout/tickets/'
      path: '/tickets'
      fullPath: '/$tenantId/tickets/'
      preLoaderRoute: typeof TenantIdLayoutTicketsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/terms-and-conditions/': {
      id: '/$tenantId/_layout/terms-and-conditions/'
      path: '/terms-and-conditions'
      fullPath: '/$tenantId/terms-and-conditions/'
      preLoaderRoute: typeof TenantIdLayoutTermsAndConditionsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/tenant-settings/': {
      id: '/$tenantId/_layout/tenant-settings/'
      path: '/tenant-settings'
      fullPath: '/$tenantId/tenant-settings/'
      preLoaderRoute: typeof TenantIdLayoutTenantSettingsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/system-administrators/': {
      id: '/$tenantId/_layout/system-administrators/'
      path: '/system-administrators'
      fullPath: '/$tenantId/system-administrators/'
      preLoaderRoute: typeof TenantIdLayoutSystemAdministratorsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/support/': {
      id: '/$tenantId/_layout/support/'
      path: '/support'
      fullPath: '/$tenantId/support/'
      preLoaderRoute: typeof TenantIdLayoutSupportIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/students/': {
      id: '/$tenantId/_layout/students/'
      path: '/'
      fullPath: '/$tenantId/students/'
      preLoaderRoute: typeof TenantIdLayoutStudentsIndexRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/search/': {
      id: '/$tenantId/_layout/search/'
      path: '/search'
      fullPath: '/$tenantId/search/'
      preLoaderRoute: typeof TenantIdLayoutSearchIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/reports/': {
      id: '/$tenantId/_layout/reports/'
      path: '/reports'
      fullPath: '/$tenantId/reports/'
      preLoaderRoute: typeof TenantIdLayoutReportsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/privacy-policy/': {
      id: '/$tenantId/_layout/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/$tenantId/privacy-policy/'
      preLoaderRoute: typeof TenantIdLayoutPrivacyPolicyIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/portal-info/': {
      id: '/$tenantId/_layout/portal-info/'
      path: '/portal-info'
      fullPath: '/$tenantId/portal-info/'
      preLoaderRoute: typeof TenantIdLayoutPortalInfoIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/periods/': {
      id: '/$tenantId/_layout/periods/'
      path: '/periods'
      fullPath: '/$tenantId/periods/'
      preLoaderRoute: typeof TenantIdLayoutPeriodsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/payers/': {
      id: '/$tenantId/_layout/payers/'
      path: '/payers'
      fullPath: '/$tenantId/payers/'
      preLoaderRoute: typeof TenantIdLayoutPayersIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/organizations/': {
      id: '/$tenantId/_layout/organizations/'
      path: '/organizations'
      fullPath: '/$tenantId/organizations/'
      preLoaderRoute: typeof TenantIdLayoutOrganizationsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/operating-status/': {
      id: '/$tenantId/_layout/operating-status/'
      path: '/operating-status'
      fullPath: '/$tenantId/operating-status/'
      preLoaderRoute: typeof TenantIdLayoutOperatingStatusIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/faq/': {
      id: '/$tenantId/_layout/faq/'
      path: '/faq'
      fullPath: '/$tenantId/faq/'
      preLoaderRoute: typeof TenantIdLayoutFaqIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/departments/': {
      id: '/$tenantId/_layout/departments/'
      path: '/departments'
      fullPath: '/$tenantId/departments/'
      preLoaderRoute: typeof TenantIdLayoutDepartmentsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/buy-ticket/': {
      id: '/$tenantId/_layout/buy-ticket/'
      path: '/buy-ticket'
      fullPath: '/$tenantId/buy-ticket/'
      preLoaderRoute: typeof TenantIdLayoutBuyTicketIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/administrators/': {
      id: '/$tenantId/_layout/administrators/'
      path: '/administrators'
      fullPath: '/$tenantId/administrators/'
      preLoaderRoute: typeof TenantIdLayoutAdministratorsIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/self-service/auth/verify': {
      id: '/$tenantId/self-service/auth/verify'
      path: '/$tenantId/self-service/auth/verify'
      fullPath: '/$tenantId/self-service/auth/verify'
      preLoaderRoute: typeof TenantIdSelfServiceAuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantId/self-service/_layout/dashboard': {
      id: '/$tenantId/self-service/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/$tenantId/self-service/dashboard'
      preLoaderRoute: typeof TenantIdSelfServiceLayoutDashboardRouteImport
      parentRoute: typeof TenantIdSelfServiceLayoutRoute
    }
    '/$tenantId/_layout/tenant-settings/$view': {
      id: '/$tenantId/_layout/tenant-settings/$view'
      path: '/tenant-settings/$view'
      fullPath: '/$tenantId/tenant-settings/$view'
      preLoaderRoute: typeof TenantIdLayoutTenantSettingsViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/reports/$view': {
      id: '/$tenantId/_layout/reports/$view'
      path: '/reports/$view'
      fullPath: '/$tenantId/reports/$view'
      preLoaderRoute: typeof TenantIdLayoutReportsViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/organizations/$view': {
      id: '/$tenantId/_layout/organizations/$view'
      path: '/organizations/$view'
      fullPath: '/$tenantId/organizations/$view'
      preLoaderRoute: typeof TenantIdLayoutOrganizationsViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/departments/_layout': {
      id: '/$tenantId/_layout/departments/_layout'
      path: '/departments'
      fullPath: '/$tenantId/departments'
      preLoaderRoute: typeof TenantIdLayoutDepartmentsLayoutRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/travellers/$travellerId/': {
      id: '/$tenantId/_layout/travellers/$travellerId/'
      path: '/travellers/$travellerId'
      fullPath: '/$tenantId/travellers/$travellerId/'
      preLoaderRoute: typeof TenantIdLayoutTravellersTravellerIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/tickets/$ticketId/': {
      id: '/$tenantId/_layout/tickets/$ticketId/'
      path: '/tickets/$ticketId'
      fullPath: '/$tenantId/tickets/$ticketId/'
      preLoaderRoute: typeof TenantIdLayoutTicketsTicketIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/system-administrators/$systemadministratorId/': {
      id: '/$tenantId/_layout/system-administrators/$systemadministratorId/'
      path: '/system-administrators/$systemadministratorId'
      fullPath: '/$tenantId/system-administrators/$systemadministratorId/'
      preLoaderRoute: typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/students/travels/': {
      id: '/$tenantId/_layout/students/travels/'
      path: '/travels'
      fullPath: '/$tenantId/students/travels/'
      preLoaderRoute: typeof TenantIdLayoutStudentsTravelsIndexRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/transportation/': {
      id: '/$tenantId/_layout/students/transportation/'
      path: '/transportation'
      fullPath: '/$tenantId/students/transportation/'
      preLoaderRoute: typeof TenantIdLayoutStudentsTransportationIndexRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/child-and-youth/': {
      id: '/$tenantId/_layout/students/child-and-youth/'
      path: '/child-and-youth'
      fullPath: '/$tenantId/students/child-and-youth/'
      preLoaderRoute: typeof TenantIdLayoutStudentsChildAndYouthIndexRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/administrators/$administratorId/': {
      id: '/$tenantId/_layout/administrators/$administratorId/'
      path: '/administrators/$administratorId'
      fullPath: '/$tenantId/administrators/$administratorId/'
      preLoaderRoute: typeof TenantIdLayoutAdministratorsAdministratorIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/travellers/$travellerId/$view': {
      id: '/$tenantId/_layout/travellers/$travellerId/$view'
      path: '/travellers/$travellerId/$view'
      fullPath: '/$tenantId/travellers/$travellerId/$view'
      preLoaderRoute: typeof TenantIdLayoutTravellersTravellerIdViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/system-administrators/$systemadministratorId/$view': {
      id: '/$tenantId/_layout/system-administrators/$systemadministratorId/$view'
      path: '/system-administrators/$systemadministratorId/$view'
      fullPath: '/$tenantId/system-administrators/$systemadministratorId/$view'
      preLoaderRoute: typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/students/travels/import': {
      id: '/$tenantId/_layout/students/travels/import'
      path: '/travels/import'
      fullPath: '/$tenantId/students/travels/import'
      preLoaderRoute: typeof TenantIdLayoutStudentsTravelsImportRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/travels/$view': {
      id: '/$tenantId/_layout/students/travels/$view'
      path: '/travels/$view'
      fullPath: '/$tenantId/students/travels/$view'
      preLoaderRoute: typeof TenantIdLayoutStudentsTravelsViewRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/transportation/import': {
      id: '/$tenantId/_layout/students/transportation/import'
      path: '/transportation/import'
      fullPath: '/$tenantId/students/transportation/import'
      preLoaderRoute: typeof TenantIdLayoutStudentsTransportationImportRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/transportation/$view': {
      id: '/$tenantId/_layout/students/transportation/$view'
      path: '/transportation/$view'
      fullPath: '/$tenantId/students/transportation/$view'
      preLoaderRoute: typeof TenantIdLayoutStudentsTransportationViewRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/child-and-youth/import': {
      id: '/$tenantId/_layout/students/child-and-youth/import'
      path: '/child-and-youth/import'
      fullPath: '/$tenantId/students/child-and-youth/import'
      preLoaderRoute: typeof TenantIdLayoutStudentsChildAndYouthImportRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/child-and-youth/$view': {
      id: '/$tenantId/_layout/students/child-and-youth/$view'
      path: '/child-and-youth/$view'
      fullPath: '/$tenantId/students/child-and-youth/$view'
      preLoaderRoute: typeof TenantIdLayoutStudentsChildAndYouthViewRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/administrators/$administratorId/$view': {
      id: '/$tenantId/_layout/administrators/$administratorId/$view'
      path: '/administrators/$administratorId/$view'
      fullPath: '/$tenantId/administrators/$administratorId/$view'
      preLoaderRoute: typeof TenantIdLayoutAdministratorsAdministratorIdViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/reports/transactions/$transactionId/': {
      id: '/$tenantId/_layout/reports/transactions/$transactionId/'
      path: '/reports/transactions/$transactionId'
      fullPath: '/$tenantId/reports/transactions/$transactionId/'
      preLoaderRoute: typeof TenantIdLayoutReportsTransactionsTransactionIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/organizations/organization/$organizationId/': {
      id: '/$tenantId/_layout/organizations/organization/$organizationId/'
      path: '/organizations/organization/$organizationId'
      fullPath: '/$tenantId/organizations/organization/$organizationId/'
      preLoaderRoute: typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/organizations/applications/$applicationId/': {
      id: '/$tenantId/_layout/organizations/applications/$applicationId/'
      path: '/organizations/applications/$applicationId'
      fullPath: '/$tenantId/organizations/applications/$applicationId/'
      preLoaderRoute: typeof TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/departments/_layout/$departmentId/': {
      id: '/$tenantId/_layout/departments/_layout/$departmentId/'
      path: '/$departmentId'
      fullPath: '/$tenantId/departments/$departmentId/'
      preLoaderRoute: typeof TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRouteImport
      parentRoute: typeof TenantIdLayoutDepartmentsLayoutRoute
    }
    '/$tenantId/_layout/students/travels/imports/$importId': {
      id: '/$tenantId/_layout/students/travels/imports/$importId'
      path: '/travels/imports/$importId'
      fullPath: '/$tenantId/students/travels/imports/$importId'
      preLoaderRoute: typeof TenantIdLayoutStudentsTravelsImportsImportIdRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/transportation/imports/$importId': {
      id: '/$tenantId/_layout/students/transportation/imports/$importId'
      path: '/transportation/imports/$importId'
      fullPath: '/$tenantId/students/transportation/imports/$importId'
      preLoaderRoute: typeof TenantIdLayoutStudentsTransportationImportsImportIdRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/students/child-and-youth/imports/$importId': {
      id: '/$tenantId/_layout/students/child-and-youth/imports/$importId'
      path: '/child-and-youth/imports/$importId'
      fullPath: '/$tenantId/students/child-and-youth/imports/$importId'
      preLoaderRoute: typeof TenantIdLayoutStudentsChildAndYouthImportsImportIdRouteImport
      parentRoute: typeof TenantIdLayoutStudentsRoute
    }
    '/$tenantId/_layout/organizations/organization/$organizationId/$view': {
      id: '/$tenantId/_layout/organizations/organization/$organizationId/$view'
      path: '/organizations/organization/$organizationId/$view'
      fullPath: '/$tenantId/organizations/organization/$organizationId/$view'
      preLoaderRoute: typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRouteImport
      parentRoute: typeof TenantIdLayoutRoute
    }
    '/$tenantId/_layout/departments/_layout/$departmentId/$view': {
      id: '/$tenantId/_layout/departments/_layout/$departmentId/$view'
      path: '/$departmentId/$view'
      fullPath: '/$tenantId/departments/$departmentId/$view'
      preLoaderRoute: typeof TenantIdLayoutDepartmentsLayoutDepartmentIdViewRouteImport
      parentRoute: typeof TenantIdLayoutDepartmentsLayoutRoute
    }
  }
}

interface TenantIdLayoutStudentsRouteChildren {
  TenantIdLayoutStudentsIndexRoute: typeof TenantIdLayoutStudentsIndexRoute
  TenantIdLayoutStudentsChildAndYouthViewRoute: typeof TenantIdLayoutStudentsChildAndYouthViewRoute
  TenantIdLayoutStudentsChildAndYouthImportRoute: typeof TenantIdLayoutStudentsChildAndYouthImportRoute
  TenantIdLayoutStudentsTransportationViewRoute: typeof TenantIdLayoutStudentsTransportationViewRoute
  TenantIdLayoutStudentsTransportationImportRoute: typeof TenantIdLayoutStudentsTransportationImportRoute
  TenantIdLayoutStudentsTravelsViewRoute: typeof TenantIdLayoutStudentsTravelsViewRoute
  TenantIdLayoutStudentsTravelsImportRoute: typeof TenantIdLayoutStudentsTravelsImportRoute
  TenantIdLayoutStudentsChildAndYouthIndexRoute: typeof TenantIdLayoutStudentsChildAndYouthIndexRoute
  TenantIdLayoutStudentsTransportationIndexRoute: typeof TenantIdLayoutStudentsTransportationIndexRoute
  TenantIdLayoutStudentsTravelsIndexRoute: typeof TenantIdLayoutStudentsTravelsIndexRoute
  TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute: typeof TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute
  TenantIdLayoutStudentsTransportationImportsImportIdRoute: typeof TenantIdLayoutStudentsTransportationImportsImportIdRoute
  TenantIdLayoutStudentsTravelsImportsImportIdRoute: typeof TenantIdLayoutStudentsTravelsImportsImportIdRoute
}

const TenantIdLayoutStudentsRouteChildren: TenantIdLayoutStudentsRouteChildren =
  {
    TenantIdLayoutStudentsIndexRoute: TenantIdLayoutStudentsIndexRoute,
    TenantIdLayoutStudentsChildAndYouthViewRoute:
      TenantIdLayoutStudentsChildAndYouthViewRoute,
    TenantIdLayoutStudentsChildAndYouthImportRoute:
      TenantIdLayoutStudentsChildAndYouthImportRoute,
    TenantIdLayoutStudentsTransportationViewRoute:
      TenantIdLayoutStudentsTransportationViewRoute,
    TenantIdLayoutStudentsTransportationImportRoute:
      TenantIdLayoutStudentsTransportationImportRoute,
    TenantIdLayoutStudentsTravelsViewRoute:
      TenantIdLayoutStudentsTravelsViewRoute,
    TenantIdLayoutStudentsTravelsImportRoute:
      TenantIdLayoutStudentsTravelsImportRoute,
    TenantIdLayoutStudentsChildAndYouthIndexRoute:
      TenantIdLayoutStudentsChildAndYouthIndexRoute,
    TenantIdLayoutStudentsTransportationIndexRoute:
      TenantIdLayoutStudentsTransportationIndexRoute,
    TenantIdLayoutStudentsTravelsIndexRoute:
      TenantIdLayoutStudentsTravelsIndexRoute,
    TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute:
      TenantIdLayoutStudentsChildAndYouthImportsImportIdRoute,
    TenantIdLayoutStudentsTransportationImportsImportIdRoute:
      TenantIdLayoutStudentsTransportationImportsImportIdRoute,
    TenantIdLayoutStudentsTravelsImportsImportIdRoute:
      TenantIdLayoutStudentsTravelsImportsImportIdRoute,
  }

const TenantIdLayoutStudentsRouteWithChildren =
  TenantIdLayoutStudentsRoute._addFileChildren(
    TenantIdLayoutStudentsRouteChildren,
  )

interface TenantIdLayoutDepartmentsLayoutRouteChildren {
  TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute: typeof TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute
  TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute: typeof TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute
}

const TenantIdLayoutDepartmentsLayoutRouteChildren: TenantIdLayoutDepartmentsLayoutRouteChildren =
  {
    TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute:
      TenantIdLayoutDepartmentsLayoutDepartmentIdViewRoute,
    TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute:
      TenantIdLayoutDepartmentsLayoutDepartmentIdIndexRoute,
  }

const TenantIdLayoutDepartmentsLayoutRouteWithChildren =
  TenantIdLayoutDepartmentsLayoutRoute._addFileChildren(
    TenantIdLayoutDepartmentsLayoutRouteChildren,
  )

interface TenantIdLayoutRouteChildren {
  TenantIdLayoutStudentsRoute: typeof TenantIdLayoutStudentsRouteWithChildren
  TenantIdLayoutIndexRoute: typeof TenantIdLayoutIndexRoute
  TenantIdLayoutDepartmentsLayoutRoute: typeof TenantIdLayoutDepartmentsLayoutRouteWithChildren
  TenantIdLayoutOrganizationsViewRoute: typeof TenantIdLayoutOrganizationsViewRoute
  TenantIdLayoutReportsViewRoute: typeof TenantIdLayoutReportsViewRoute
  TenantIdLayoutTenantSettingsViewRoute: typeof TenantIdLayoutTenantSettingsViewRoute
  TenantIdLayoutAdministratorsIndexRoute: typeof TenantIdLayoutAdministratorsIndexRoute
  TenantIdLayoutBuyTicketIndexRoute: typeof TenantIdLayoutBuyTicketIndexRoute
  TenantIdLayoutDepartmentsIndexRoute: typeof TenantIdLayoutDepartmentsIndexRoute
  TenantIdLayoutFaqIndexRoute: typeof TenantIdLayoutFaqIndexRoute
  TenantIdLayoutOperatingStatusIndexRoute: typeof TenantIdLayoutOperatingStatusIndexRoute
  TenantIdLayoutOrganizationsIndexRoute: typeof TenantIdLayoutOrganizationsIndexRoute
  TenantIdLayoutPayersIndexRoute: typeof TenantIdLayoutPayersIndexRoute
  TenantIdLayoutPeriodsIndexRoute: typeof TenantIdLayoutPeriodsIndexRoute
  TenantIdLayoutPortalInfoIndexRoute: typeof TenantIdLayoutPortalInfoIndexRoute
  TenantIdLayoutPrivacyPolicyIndexRoute: typeof TenantIdLayoutPrivacyPolicyIndexRoute
  TenantIdLayoutReportsIndexRoute: typeof TenantIdLayoutReportsIndexRoute
  TenantIdLayoutSearchIndexRoute: typeof TenantIdLayoutSearchIndexRoute
  TenantIdLayoutSupportIndexRoute: typeof TenantIdLayoutSupportIndexRoute
  TenantIdLayoutSystemAdministratorsIndexRoute: typeof TenantIdLayoutSystemAdministratorsIndexRoute
  TenantIdLayoutTenantSettingsIndexRoute: typeof TenantIdLayoutTenantSettingsIndexRoute
  TenantIdLayoutTermsAndConditionsIndexRoute: typeof TenantIdLayoutTermsAndConditionsIndexRoute
  TenantIdLayoutTicketsIndexRoute: typeof TenantIdLayoutTicketsIndexRoute
  TenantIdLayoutTravellersIndexRoute: typeof TenantIdLayoutTravellersIndexRoute
  TenantIdLayoutUserIndexRoute: typeof TenantIdLayoutUserIndexRoute
  TenantIdLayoutAdministratorsAdministratorIdViewRoute: typeof TenantIdLayoutAdministratorsAdministratorIdViewRoute
  TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute: typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute
  TenantIdLayoutTravellersTravellerIdViewRoute: typeof TenantIdLayoutTravellersTravellerIdViewRoute
  TenantIdLayoutAdministratorsAdministratorIdIndexRoute: typeof TenantIdLayoutAdministratorsAdministratorIdIndexRoute
  TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute: typeof TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute
  TenantIdLayoutTicketsTicketIdIndexRoute: typeof TenantIdLayoutTicketsTicketIdIndexRoute
  TenantIdLayoutTravellersTravellerIdIndexRoute: typeof TenantIdLayoutTravellersTravellerIdIndexRoute
  TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute: typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute
  TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute: typeof TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute
  TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute: typeof TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute
  TenantIdLayoutReportsTransactionsTransactionIdIndexRoute: typeof TenantIdLayoutReportsTransactionsTransactionIdIndexRoute
}

const TenantIdLayoutRouteChildren: TenantIdLayoutRouteChildren = {
  TenantIdLayoutStudentsRoute: TenantIdLayoutStudentsRouteWithChildren,
  TenantIdLayoutIndexRoute: TenantIdLayoutIndexRoute,
  TenantIdLayoutDepartmentsLayoutRoute:
    TenantIdLayoutDepartmentsLayoutRouteWithChildren,
  TenantIdLayoutOrganizationsViewRoute: TenantIdLayoutOrganizationsViewRoute,
  TenantIdLayoutReportsViewRoute: TenantIdLayoutReportsViewRoute,
  TenantIdLayoutTenantSettingsViewRoute: TenantIdLayoutTenantSettingsViewRoute,
  TenantIdLayoutAdministratorsIndexRoute:
    TenantIdLayoutAdministratorsIndexRoute,
  TenantIdLayoutBuyTicketIndexRoute: TenantIdLayoutBuyTicketIndexRoute,
  TenantIdLayoutDepartmentsIndexRoute: TenantIdLayoutDepartmentsIndexRoute,
  TenantIdLayoutFaqIndexRoute: TenantIdLayoutFaqIndexRoute,
  TenantIdLayoutOperatingStatusIndexRoute:
    TenantIdLayoutOperatingStatusIndexRoute,
  TenantIdLayoutOrganizationsIndexRoute: TenantIdLayoutOrganizationsIndexRoute,
  TenantIdLayoutPayersIndexRoute: TenantIdLayoutPayersIndexRoute,
  TenantIdLayoutPeriodsIndexRoute: TenantIdLayoutPeriodsIndexRoute,
  TenantIdLayoutPortalInfoIndexRoute: TenantIdLayoutPortalInfoIndexRoute,
  TenantIdLayoutPrivacyPolicyIndexRoute: TenantIdLayoutPrivacyPolicyIndexRoute,
  TenantIdLayoutReportsIndexRoute: TenantIdLayoutReportsIndexRoute,
  TenantIdLayoutSearchIndexRoute: TenantIdLayoutSearchIndexRoute,
  TenantIdLayoutSupportIndexRoute: TenantIdLayoutSupportIndexRoute,
  TenantIdLayoutSystemAdministratorsIndexRoute:
    TenantIdLayoutSystemAdministratorsIndexRoute,
  TenantIdLayoutTenantSettingsIndexRoute:
    TenantIdLayoutTenantSettingsIndexRoute,
  TenantIdLayoutTermsAndConditionsIndexRoute:
    TenantIdLayoutTermsAndConditionsIndexRoute,
  TenantIdLayoutTicketsIndexRoute: TenantIdLayoutTicketsIndexRoute,
  TenantIdLayoutTravellersIndexRoute: TenantIdLayoutTravellersIndexRoute,
  TenantIdLayoutUserIndexRoute: TenantIdLayoutUserIndexRoute,
  TenantIdLayoutAdministratorsAdministratorIdViewRoute:
    TenantIdLayoutAdministratorsAdministratorIdViewRoute,
  TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute:
    TenantIdLayoutSystemAdministratorsSystemadministratorIdViewRoute,
  TenantIdLayoutTravellersTravellerIdViewRoute:
    TenantIdLayoutTravellersTravellerIdViewRoute,
  TenantIdLayoutAdministratorsAdministratorIdIndexRoute:
    TenantIdLayoutAdministratorsAdministratorIdIndexRoute,
  TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute:
    TenantIdLayoutSystemAdministratorsSystemadministratorIdIndexRoute,
  TenantIdLayoutTicketsTicketIdIndexRoute:
    TenantIdLayoutTicketsTicketIdIndexRoute,
  TenantIdLayoutTravellersTravellerIdIndexRoute:
    TenantIdLayoutTravellersTravellerIdIndexRoute,
  TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute:
    TenantIdLayoutOrganizationsOrganizationOrganizationIdViewRoute,
  TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute:
    TenantIdLayoutOrganizationsApplicationsApplicationIdIndexRoute,
  TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute:
    TenantIdLayoutOrganizationsOrganizationOrganizationIdIndexRoute,
  TenantIdLayoutReportsTransactionsTransactionIdIndexRoute:
    TenantIdLayoutReportsTransactionsTransactionIdIndexRoute,
}

const TenantIdLayoutRouteWithChildren = TenantIdLayoutRoute._addFileChildren(
  TenantIdLayoutRouteChildren,
)

interface TenantIdSelfServiceLayoutRouteChildren {
  TenantIdSelfServiceLayoutDashboardRoute: typeof TenantIdSelfServiceLayoutDashboardRoute
}

const TenantIdSelfServiceLayoutRouteChildren: TenantIdSelfServiceLayoutRouteChildren =
  {
    TenantIdSelfServiceLayoutDashboardRoute:
      TenantIdSelfServiceLayoutDashboardRoute,
  }

const TenantIdSelfServiceLayoutRouteWithChildren =
  TenantIdSelfServiceLayoutRoute._addFileChildren(
    TenantIdSelfServiceLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessibilityRoute: AccessibilityRoute,
  DowntimeRoute: DowntimeRoute,
  ProfilesRoute: ProfilesRoute,
  TenantIdLayoutRoute: TenantIdLayoutRouteWithChildren,
  TenantIdLoginRoute: TenantIdLoginRoute,
  TenantIdLogoutRoute: TenantIdLogoutRoute,
  TenantIdRegisterRoute: TenantIdRegisterRoute,
  OfferingsOfferIdRoute: OfferingsOfferIdRoute,
  OfferingsLayoutRoute: OfferingsLayoutRoute,
  OfferingsIndexRoute: OfferingsIndexRoute,
  TenantIdSelfServiceLayoutRoute: TenantIdSelfServiceLayoutRouteWithChildren,
  TenantIdSelfServiceLoginRoute: TenantIdSelfServiceLoginRoute,
  TenantIdMenuIndexRoute: TenantIdMenuIndexRoute,
  TenantIdSelfServiceIndexRoute: TenantIdSelfServiceIndexRoute,
  TenantIdSelfServiceAuthVerifyRoute: TenantIdSelfServiceAuthVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
